import {memo} from 'react';

import styled from 'styled-components';

import {body11Bold} from '~/shared/theme/typography';

const AlcoholWarning = styled.div`
  ${body11Bold}
  border: 1px solid ${({theme}) => theme.colors.gray000};
  padding: 2px 4px;
  border-radius: 4px;
  width: fit-content;
  height: 24px;
  align-items: center;
  display: flex;
`;

const ALCOHOL_INDICATIOR = 15.5;
         
const AlcoholPercentageWarning = ({alcoholPercentage}: {alcoholPercentage: number}) => {
  // will always be on hebrew.
  if (!alcoholPercentage) {
    return null;
  }

  if (alcoholPercentage > ALCOHOL_INDICATIOR) {
    return <AlcoholWarning>אזהרה: צריכה מופרזת של אלכוהול מסכנת חיים ומזיקה לבריאות</AlcoholWarning>;
  }

  return <AlcoholWarning>אזהרה: מכיל אלכוהול - מומלץ להימנע משתיה מופרזת</AlcoholWarning>;
};

export default memo(AlcoholPercentageWarning);
